import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Overview = () => import('@/views/Overview')
const Ewallet = () => import('@/views/EwalletView')
const EwalletSchedule = () => import('@/views/EwalletSchedule')
const LoginUser = () => import('@/views/Login')
const JoinGroup = () => import('@/views/JoinGroup')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const List = () => import('@/views/template/List')
const TemplateHome = () => import('@/views/template/Homepage')
const SalesReport = () => import('@/views/analysis/SalesReport')
const ProductReport = () => import('@/views/analysis/ProductReport')
const AffiliateStaff = () => import('@/views/analysis/AffiliateStaff')
const AffiliateExternal = () => import('@/views/analysis/AffiliateExternal')
const PurchaseSummary = () => import('@/views/analysis/PurchaseSummary')
const ListAffiliate = () => import('@/views/analysis/ListAffiliate')
const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')

const Profile = () => import('@/views/Profile')
const Billing = () => import('@/views/Billing')
const Schedule = () => import('@/views/Schedule')
const Scheduler = () => import('@/views/Scheduler')
const RegisterStudent = () => import('@/views/RegisterStudent')
const Notification = () => import('@/views/Notification')
const SignUp = () => import('@/views/SignUp')
const ForgotPassword = () => import('@/views/ForgotPassword')
const ListClass = () => import('@/views/ListClass')
const DetailJoinClass = () => import('@/views/DetailJoinClass')
const EPayTrack = () => import('@/views/EPayTrack')
const TuitionMassNotificationList = () => import('@/views/TuitionMassNotificationList')
const RenewSubscription = () => import('@/views/RenewSubscription')

const QuizStudent = () => import('@/views/QuizStudent')
const QuizGrade = () => import('@/views/QuizGrade')
const QuizSubject = () => import('@/views/QuizSubject')
const QuizStudentDashboard = () => import('@/views/QuizStudentDashboard')
const QuizStudentQuizList = () => import('@/views/QuizStudentQuizList')
const QuizStudentDescription = () => import('@/views/QuizStudentDescription')
const QuizStudentQuestions = () => import('@/views/QuizStudentQuestion')
const Index = () => import('@/views/Index')
const QuizStudentFinalScore = () => import('@/views/QuizStudentFinalScore')
const QuizStudentExam = () => import('@/views/QuizStudentExam')
const QuizStudentExamList = () => import('@/views/QuizStudentExamList')
const QuizStudentQuizDetail = () => import('@/views/QuizStudentQuizDetail')
const QuizStudentLeaderBoard = () => import('@/views/QuizStudentLeaderBoard')
const QuizStudentOverview = () => import('@/views/QuizStudentOverview')
const QuizStudentProfile = () => import('@/views/QuizStudentProfile')
const QuizStudentAnswerPreview = () => import('@/views/QuizStudentAnswerPreview')
const QuizStudentDaily = () => import('@/views/QuizStudentDaily')
const QuizStudentEwallet = () => import('@/views/QuizStudentEwallet')
const QuizStudentListQuestion = () => import('@/views/QuizStudentListQuestion')

const QuizTeacherAcademicProfile = () => import('@/views/QuizTeacherAcademicProfile')
const QuizTeacherAreaExpertise = () => import('@/views/QuizTeacherAreaExpertise')
const QuizTeacherCreateQuestion = () => import('@/views/QuizTeacherCreateQuestion')
const QuizTeacherCreateTitle = () => import('@/views/QuizTeacherCreateTitle')
const QuizTeacherDashboard = () => import('@/views/QuizTeacherDashboard')
const QuizTeacherDescription = () => import('@/views/QuizTeacherDescription')
const QuizTeacherDraft = () => import('@/views/QuizTeacherDraft')
const QuizTeacherEditQuestion = () => import('@/views/QuizTeacherEditQuestion')
const QuizTeacherLeaderBoard = () => import('@/views/QuizTeacherLeaderBoard')
const QuizTeacherPreview = () => import('@/views/QuizTeacherPreview')
const QuizTeacherProfession = () => import('@/views/QuizTeacherProfession')
const QuizTeacherProfile = () => import('@/views/QuizTeacherProfile')
const QuizTeacherQuizList = () => import('@/views/QuizTeacherQuizList')
const QuizTeacherStatistic = () => import('@/views/QuizTeacherStatistic')
const QuizTeacherTestOverview = () => import('@/views/QuizTeacherTestOverview')
const QuizTeacherTestResult = () => import('@/views/QuizTeacherTestResult')
const QuizTeacherWorkBackground = () => import('@/views/QuizTeacherWorkBackground')

const EPayTransaction = () => import('@/views/EPayTransaction')
const EPayTotal = () => import('@/views/EPayTotal')
const DuplicateTransaction = () => import('@/views/DuplicateTransaction')

const FindTutorMsgAnalysis = () => import('@/views/FindTutorMsgAnalysis')
const FindTutorStillOpen = () => import('@/views/FindTutorStillOpen')
const FindTutorTeacherApply = () => import('@/views/FindTutorTeacherApply')


const RegisterTc = () => import('@/views/RegisterTc')
const TuitionSubject = () => import('@/views/TuitionSubject')
const TuitionPackage = () => import('@/views/TuitionPackage')
const TuitionSchedule = () => import('@/views/TuitionSchedule')
const TuitionRegistrationStudent = () => import('@/views/TuitionRegistrationStudent')
const TuitionRegistrationAdmin = () => import('@/views/TuitionRegisterAdmin')
const TuitionStudent = () => import('@/views/TuitionStudent')
const TuitionTeacher = () => import('@/views/TuitionTeacher')
const TuitionAttendanceStudent = () => import('@/views/TuitionAttendanceStudent')
const TuitionAttendanceTeacher = () => import('@/views/TuitionAttendanceTeacher')
const TuitionPaymentStudent = () => import('@/views/TuitionPaymentStudent')
const TuitionPaymentTeacher = () => import('@/views/TuitionPaymentTeacher')
const TuitionBroadcast = () => import('@/views/TuitionBroadcast')
const TuitionAssignSubject = () => import('@/views/TuitionAssignSubject')
const TuitionSubjectSetSchedule = () => import('@/views/TuitionSubjectSetSchedule')
const EditPackage = () => import('@/views/EditPackage')
const DetailStudent = () => import('@/views/DetailStudent')
const AddDiscount = () => import('@/views/AddDiscount')
const SetPackage = () => import('@/views/SetPackage')
const EditStudent = () => import('@/views/EditStudent')
const PopupUpdateTeacher = () => import('@/views/PopupUpdateTeacher')
const PopupStudentTuitionAttendance = () => import('@/views/PopupStudentTuitionAttendance')
const PopupPaymentStudent = () => import('@/views/PopupPaymentStudent')
const PopupPaymentTeacher = () => import('@/views/PopupPaymentTeacher')
const StudentPaymentReceipt = () => import('@/views/StudentPaymentReceipt')
const TeacherPaymentSlip = () => import('@/views/TeacherPaymentSlip')
const calendar = () => import('@/views/calendar')
const TuitionMassNotification = () => import('@/views/TuitionMassNotification')
const TuitionStudentNew = () => import('@/views/TuitionStudentNew')
const TuitionRegistrationFee = () => import('@/views/TuitionRegistrationFee')

const GeneratePaymentStudent = () => import('@/views/GeneratePaymentStudent')

const Learning = () => import('@/views/Learning')
const LearningSubject = () => import('@/views/LearningSubject')
const LearningClass = () => import('@/views/LearningClass')
const LearningAttendance = () => import('@/views/LearningAttendance')
const LearningUser = () => import('@/views/LearningUser')
const PaginatePage = () => import('@/views/PaginatePage')
const AutoLogout = () => import('@/views/AutoLogout')
const SuccessfullPayment = () => import('@/views/SuccessfullPayment')
const FindTutor = () => import('@/views/FindTutor')

const Manage = () => import('@/views/Manage')
const FindTutorExam  = () => import('@/views/FindTutorExam')
const TutorList  = () => import('@/views/TutorList')
const TuitionCenter  = () => import('@/views/TuitionCenter')
const UnPaidTransaction  = () => import('@/views/UnPaidTransaction')
const CounterVisitor  = () => import('@/views/CounterVisitor')
const ProfileTuitionCenter  = () => import('@/views/ProfileTuitionCenter')
const ManagePackage  = () => import('@/views/ManagePackage')
const LearningStudent  = () => import('@/views/LearningStudent')
const TestingPage  = () => import('@/views/TestingPage')
const ScheduleList  = () => import('@/views/ScheduleList')
const CouponPage  = () => import('@/views/CouponPage')
const ListUser  = () => import('@/views/analysis/ListUser')
Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: configRoutes()
})
function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/Login',
      name: 'Login',
      component: TheContainer,
      props: {
        default: true,
        sidebar: false
      },
      children: [
        {
          path: 'Dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'Learning',
          name: 'Learning',
          component: Learning
        },
        {
          path: 'LearningSubject',
          name: 'LearningSubject',
          component: LearningSubject
        },
        {
          path: 'LearningClass',
          name: 'LearningClass',
          component: LearningClass
        },
        {
          path: 'LearningAttendance',
          name: 'LearningAttendance',
          component: LearningAttendance
        },
        {
          path: 'LearningUser',
          name: 'LearningUser',
          component: LearningUser
        },
        {
          path: 'PaginatePage',
          name: 'PaginatePage',
          component: PaginatePage
        },
        {
          path: 'GeneratePaymentStudent',
          name: 'Generate Payment Student',
          component: GeneratePaymentStudent
        },
        {
          path: 'Overview',
          name: 'Overview',
          component: Overview
        },
        {
          path: 'Profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'EwalletView',
          name: 'EWallet',
          component: Ewallet
        },
        {
          path: 'EwalletSchedule',
          name: 'EWallet Schedule',
          component: EwalletSchedule
        },
        {
          path: 'Scheduler',
          name: 'Scheduler',
          component: Scheduler
        },
        {
          path: 'ListClass',
          name: 'Join Available Class',
          component: ListClass
        },
        {
          path: 'DetailJoinClass',
          name: 'Detail Class',
          component: DetailJoinClass
        },
        {
          path: 'Billing',
          name: 'Billing',
          component: Billing
        },
        {
          path: 'Schedule',
          name: 'Schedule',
          component: Schedule
        },
        {
          path: 'JoinGroup',
          name: 'Join Group',
          component: JoinGroup
        },
        {
          path: 'CouponPage',
          name: 'Manage Coupon',
          component: CouponPage
        },
        {
          path: 'RegisterStudent',
          name: 'Register Student',
          component: RegisterStudent
        },
        {
          path: 'Notification',
          name: 'Notification',
          component: Notification
        },
        {
          path: 'AutoLogout',
          name: 'AutoLogout',
          component: AutoLogout
        },
        {
          path: 'QuizGrade',
          name: 'Quiz Grade',
          component: QuizGrade
        },
        {
          path: 'QuizSubject',
          name: 'Quiz Subject',
          component: QuizSubject
        },
        {
          path: 'QuizStudent',
          name: 'Quiz Student',
          component: QuizStudent
        },
        {
          path: 'QuizStudentDashboard',
          name: 'Quiz Student Dashboard',
          component: QuizStudentDashboard
        },
        {
          path: 'QuizStudentQuizList',
          name: 'Quiz Student Quiz List',
          component: QuizStudentQuizList
        },
        {
          path: 'QuizStudentDescription',
          name: 'Quiz Student Description',
          component: QuizStudentDescription
        },
        {
          path: 'QuizStudentQuestion',
          name: 'Quiz Student Question',
          component: QuizStudentQuestions
        },
        {
          path: 'Index',
          name: 'Index',
          component: Index
        },
        {
          path: 'QuizStudentFinalScore',
          name: 'QuizStudentFinalScore',
          component: QuizStudentFinalScore
        },
        {
          path: 'QuizStudentExam',
          name: 'QuizStudentExam',
          component: QuizStudentExam
        },
        {
          path: 'QuizStudentExamList',
          name: 'QuizStudentExamList',
          component: QuizStudentExamList
        },
        {
          path: 'QuizStudentQuizDetail',
          name: 'QuizStudentQuizDetail',
          component: QuizStudentQuizDetail
        },
        {
          path: 'QuizStudentLeaderBoard',
          name: 'QuizStudentLeaderBoard',
          component: QuizStudentLeaderBoard
        },
        {
          path: 'QuizStudentOverview',
          name: 'QuizStudentOverview',
          component: QuizStudentOverview
        },
        {
          path: 'QuizStudentProfile',
          name: 'QuizStudentProfile',
          component: QuizStudentProfile
        },
        {
          path: 'QuizStudentAnswerPreview',
          name: 'QuizStudentAnswerPreview',
          component: QuizStudentAnswerPreview
        },
        {
          path: 'QuizStudentDaily',
          name: 'QuizStudentDaily',
          component: QuizStudentDaily
        },
        {
          path: 'QuizStudentEwallet',
          name: 'QuizStudentEwallet',
          component: QuizStudentEwallet
        },
        {
          path: 'QuizStudentListQuestion',
          name: 'QuizStudentListQuestion',
          component: QuizStudentListQuestion
        },
        {
          path: 'QuizTeacherAcademicProfile',
          name: 'QuizTeacherAcademicProfile',
          component: QuizTeacherAcademicProfile
        },
        {
          path: 'QuizTeacherAreaExpertise',
          name: 'QuizTeacherAreaExpertise',
          component: QuizTeacherAreaExpertise
        },
        {
          path: 'QuizTeacherCreateQuestion',
          name: 'QuizTeacherCreateQuestion',
          component: QuizTeacherCreateQuestion
        },
        {
          path: 'QuizTeacherCreateTitle',
          name: 'QuizTeacherCreateTitle',
          component: QuizTeacherCreateTitle
        },
        {
          path: 'QuizTeacherDashboard',
          name: 'QuizTeacherDashboard',
          component: QuizTeacherDashboard
        },
        {
          path: 'QuizTeacherDescription',
          name: 'QuizTeacherDescription',
          component: QuizTeacherDescription
        },
        {
          path: 'QuizTeacherDraft',
          name: 'QuizTeacherDraft',
          component: QuizTeacherDraft
        },
        {
          path: 'QuizTeacherEditQuestion',
          name: 'QuizTeacherEditQuestion',
          component: QuizTeacherEditQuestion
        },
        {
          path: 'QuizTeacherLeaderBoard',
          name: 'QuizTeacherLeaderBoard',
          component: QuizTeacherLeaderBoard
        },
        {
          path: 'QuizTeacherPreview',
          name: 'QuizTeacherPreview',
          component: QuizTeacherPreview
        },
        {
          path: 'QuizTeacherProfession',
          name: 'QuizTeacherProfession',
          component: QuizTeacherProfession
        },
        {
          path: 'QuizTeacherProfile',
          name: 'QuizTeacherProfile',
          component: QuizTeacherProfile
        },
        {
          path: 'QuizTeacherQuizList',
          name: 'QuizTeacherQuizList',
          component: QuizTeacherQuizList
        },
        {
          path: 'QuizTeacherStatistic',
          name: 'QuizTeacherStatistic',
          component: QuizTeacherStatistic
        },
        {
          path: 'QuizTeacherTestOverview',
          name: 'QuizTeacherTestOverview',
          component: QuizTeacherTestOverview
        },
        {
          path: 'QuizTeacherTestResult',
          name: 'QuizTeacherTestResult',
          component: QuizTeacherTestResult
        },
        {
          path: 'QuizTeacherWorkBackground',
          name: 'QuizTeacherWorkBackground',
          component: QuizTeacherWorkBackground
        },
        {
          path: 'FindTutor',
          name: 'FindTutor',
          component: FindTutor
        },
        {
          path: 'EPayTransaction',
          name: 'E-Pay Transaction',
          component: EPayTransaction
        },
        {
          path: 'EPaytotal',
          name: 'E-Pay Total',
          component: EPayTotal
        },
        {
          path: 'EPayTrack',
          name: 'E-Pay Track',
          component: EPayTrack
        },
        {
          path: 'FindTutorMsgAnalysis',
          name: 'Msg Analysis',
          component: FindTutorMsgAnalysis
        },
        {
          path: 'FindTutorStillOpen',
          name: 'Still Open',
          component: FindTutorStillOpen
        },
        {
          path: 'FindTutorTeacherApply',
          name: 'Teacher Apply',
          component: FindTutorTeacherApply
        },
        {
          path: 'DuplicateTransaction',
          name: 'Duplicate Transaction',
          component: DuplicateTransaction
        },
        {
          path: 'TuitionSubject',
          name: 'Tuition Subject',
          component: TuitionSubject
        },
        {
          path: 'TuitionPackage',
          name: 'Tuition Package',
          component: TuitionPackage
        },
        {
          path: 'TuitionSchedule',
          name: 'Tuition Schedule',
          component: TuitionSchedule
        },
        {
          path: 'TuitionRegistrationStudent',
          name: 'Register Student',
          component: TuitionRegistrationStudent
        },
        {
          path: 'TuitionRegisterAdmin',
          name: 'Register Admin',
          component: TuitionRegistrationAdmin
        },
        {
          path: 'TuitionStudent',
          name: 'Tuition Student',
          component: TuitionStudent
        },
        {
          path: 'TuitionTeacher',
          name: 'Tuition Teacher',
          component: TuitionTeacher
        },
        {
          path: 'TuitionAttendanceTeacher',
          name: 'Tuition Attendance Teacher',
          component: TuitionAttendanceTeacher
        },
        {
          path: 'TuitionAttendanceStudent',
          name: 'Tuition Attendance Student',
          component: TuitionAttendanceStudent
        },
        {
          path: 'TuitionPaymentStudent',
          name: 'Tuition Payment Student',
          component: TuitionPaymentStudent
        },
        {
          path: 'TuitionPaymentTeacher',
          name: 'Tuition Payment Teacher',
          component: TuitionPaymentTeacher
        },
        {
          path: 'TuitionBroadcast',
          name: 'Tuition Broadcast',
          component: TuitionBroadcast
        },
        {
          path: 'TuitionAssignSubject',
          name: 'Assign Subject',
          component: TuitionAssignSubject
        },
        {
          path: 'TuitionSubjectSetSchedule',
          name: 'Tuition Schedule',
          component: TuitionSubjectSetSchedule
        },
        {
          path: 'TuitionRegistrationFee',
          name: 'Tuition Registration Fee',
          component: TuitionRegistrationFee
        },
        {
          path: 'EditPackage',
          name: 'Edit Package',
          component: EditPackage
        },
        {
          path: 'DetailStudent',
          name: 'Student',
          component: DetailStudent
        },
        {
          path: 'AddDiscount',
          name: 'Purchase',
          component: AddDiscount
        },
        {
          path: 'SetPackage',
          name: 'Package',
          component: SetPackage
        },
        {
          path: 'EditStudent',
          name: 'Student',
          component: EditStudent
        },
        {
          path: 'PopupUpdateTeacher',
          name: 'Update Teacher',
          component: PopupUpdateTeacher
        },
        {
          path: 'PopupStudentTuitionAttendance',
          name: 'Student Attendance',
          component: PopupStudentTuitionAttendance
        },
        {
          path: 'PopupPaymentStudent',
          name: 'Payment Student',
          component: PopupPaymentStudent
        },
        {
          path: 'PopupPaymentTeacher',
          name: 'Payment Teacher',
          component: PopupPaymentTeacher
        },
        {
          path: 'StudentPaymentReceipt',
          name: 'Payment Receipt',
          component: StudentPaymentReceipt
        },
        {
          path: 'TeacherPaymentSlip',
          name: 'SalarySlip',
          component: TeacherPaymentSlip
        },
        {
          path: 'calendar',
          name: 'Calendar',
          component: calendar
        },
        {
          path: 'TuitionMassNotification',
          name: 'Tuition Mass Notification',
          component: TuitionMassNotification
        },
        {
          path: 'TuitionMassNotificationList',
          name: 'Tuition Mass Notification',
          component: TuitionMassNotificationList
        },
        {
          path: 'TuitionStudentNew',
          name: 'TuitionStudent(New)',
          component: TuitionStudentNew
        },
        {
          path: 'Manage',
          name: 'Manage',
          component: Manage
        },
        {
          path: 'FindTutorExam',
          name: 'Find Tutor Exam',
          component: FindTutorExam
        },
        {
          path: 'TutorList',
          name: 'Tutor List',
          component: TutorList
        },
        {
          path: 'TuitionCenter',
          name: 'Tuition Center',
          component: TuitionCenter
        },
        {
          path: 'UnPaidTransaction',
          name: 'UnPaid Transaction',
          component: UnPaidTransaction
        },
        {
          path: 'CounterVisitor',
          name: 'CounterVisitor',
          component: CounterVisitor
        },
        {
          path: 'ProfileTuitionCenter',
          name: 'ProfileTuitionCenter',
          component: ProfileTuitionCenter
        },
        {
          path: 'ManagePackage',
          name: 'ManagePackage',
          component: ManagePackage
        },
       
        {
          path: 'LearningStudent',
          name: 'LearningStudent',
          component: LearningStudent
        },
        {
          path: 'ScheduleList',
          name: 'ScheduleList',
          component: ScheduleList
        },
        
         {
          path: 'template',
          redirect: '/template/list',
          name: 'Template',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/template/List',
              name: 'List',
              component: List
            },
            {
              path: '/template/Homepage',
              name: 'Homepage',
              component: TemplateHome
            },
           
          ]
        },
        {
          path: 'analysis',
          redirect: '/analysis/salesReport',
          name: 'Analysis',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/analysis/salesReport',
              name: 'Sales Report',
              component: SalesReport
            },
            {
              path: '/analysis/productReport',
              name: 'Product Report',
              component: ProductReport
            },
            {
              path: '/analysis/affiliateStaff',
              name: 'Affiliate Staff',
              component: AffiliateStaff
            },
            {
              path: '/analysis/affiliateExternal',
              name: 'Affiliate External',
              component:AffiliateExternal
            },
            {
              path: '/analysis/purchaseSummary',
              name: 'Purchase Summary',
              component:PurchaseSummary
            },
            {
              path: '/analysis/listAffiliate',
              name: 'List Affiliate',
              component:ListAffiliate
            },
            {
              path: '/analysis/ListUser',
              name: 'List User',
              component:ListUser
            }
          
          ]
        },
        
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            },
            {
              path: 'typography',
              name: 'Typography',
              component: CoreUIIcons
            },
            {
              path: 'EwalletView',
              name: 'EWallet',
              component: Ewallet
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
      ],
      
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Login',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'login',
        name: 'login',
        component: LoginUser
      }, ]
    },
    {
      path: '/',
      redirect: '/SignUp',
      name: 'SignUp',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'SignUp',
        name: 'SignUp',
        component: SignUp
      }, ]
    },
    {
      path: '/',
      redirect: '/ForgotPassword',
      name: 'ForgotPassword',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'ForgotPassword',
        name: 'ForgotPassword',
        component: ForgotPassword
      }, ]
    },
    {
      path: '/',
      redirect: '/RegisterTc',
      name: 'Register Tuition Center',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'RegisterTc',
        name: 'RegisterTc',
        component: RegisterTc
      }, ]
    },
    {
      path: '/',
      redirect: '/RenewSubscription',
      name: 'RenewSubscription',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'RenewSubscription',
        name: 'RenewSubscription',
        component: RenewSubscription
      }, ]
    },
    {
      path: '/',
      redirect: '/SuccessfullPayment',
      name: 'SuccessfullPayment',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'SuccessfullPayment',
          name: 'SuccessfullPayment',
          component: SuccessfullPayment
        },

      ]
    },
    {
      path: '/',
      redirect: '/TestingPage',
      name: 'TestingPage',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'TestingPage',
          name: 'TestingPage',
          component: TestingPage
        },

      ]
    },
   
    
  ]
}
